import { dataZoomOutSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconZoomOutSolid = /*#__PURE__*/createIcon(dataZoomOutSolid)
export default IconZoomOutSolid
